
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import scheduledStatus from '@/enums/scheduledStatus';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { scheduledmessage } = api;

interface ScheduledMessage {
  scheduledMessageId: string;
  msgBody: string;
  isEnabled: boolean;
  status: number;
  sendTime: string;
  createdOn: string;
}

@Component({
  components: { DateRange },
})
export default class ScheduledMessageList extends Vue {
  private data: {
    data: ScheduledMessage[];
    totalCount: number;
    pageSize: number;
    pageNo: number;
  } = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private scheduledStatus = scheduledStatus;

  private headers = [
    { text: '推播內容', value: 'msgBody' },
    { text: '發送時間', value: 'sendTime' },
    { text: '建立時間', value: 'createdOn' },
    { text: '狀態', value: 'status' },
    { text: '是否啟用', value: 'isEnabled' },
    { text: '修改', value: 'edit' },
    { text: '刪除', value: 'delete' },
    { text: '匯出', value: 'export' },
  ];

  private schduledStatusType: Array<{ value: number; text: string}> = [
    { value: 0, text: '全部' },
    { value: 1, text: '排程中' },
    { value: 2, text: '已發送' },
    { value: 3, text: '未啟用' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    msgBody: this.$route.query.msgBody || undefined,
    status: this.$route.query.status || undefined,
    sendTime: this.$route.query.sendTime || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      msgBody: undefined,
      status: undefined,
      sendTime: undefined,
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private statusText(status: number) {
    const statusItem = this.schduledStatusType.find((item: { value: number; text: string}) => item.value === status);
    return statusItem?.text;
  }

  private async handleDelete(id: any) {
    await Swal.fire(
      {
        title: '你確定要刪除推播訊息嗎',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await scheduledmessage.delete(id);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.query();
        } else {
          await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
        }
      }
    });
  }

  private async handleExport(id: any) {
    const { status, data } = await scheduledmessage.export(id) || {};
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '推播名單.txt');
  }

  private async requestData() {
    this.loading = true;
    const { data } = await scheduledmessage.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ScheduledMessageList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
